import React, { useRef, useState } from "react";
import { Button, Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import VEN_DocsVenta_Detalle from "./VEN_DocsVenta_Detalle";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";
import { function_VEN_DocsVenta_Cabecera_Eliminar, function_VEN_DocsVenta_Cabecera_ReporteDocVenta, function_VEN_DocsVenta_Cabecera_ReporteDocVenta_EnvioMail } from "neftis7_apicaller/src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";

export const VEN_DocsVenta_ = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const { VEN_DocsVenta_Cabecera: { function_VEN_DocsVenta_Cabecera_Listar } } = require('neftis7_apicaller');
  const refRecargaListado = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const onClickDelete = (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {
      
      const setData = async () => {
        try {
          await function_VEN_DocsVenta_Cabecera_Eliminar(Item.IdDocVenta)
          refRecargaListado.current?.(); 
        } catch (error) {
          alert(error);
        }
      }
      setData();
    }
  };

  const handleOnClickPrint = async (item) => {
    try {
      setLoading(true);
      const formato = "pdf"
      const reportData = await function_VEN_DocsVenta_Cabecera_ReporteDocVenta(item.IdDocVenta, formato);

      if (formato === 'pdf') {
        const file = new Blob([reportData], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `DocVenta${item.IdDocVenta}.pdf`; // Nombre del archivo con extensión
        link.click();
      } else if (formato === 'html') {
        const htmlContent = reportData.data;
        const newWindow = window.open();
        newWindow.document.write(htmlContent); // Mostrar HTML en nueva ventana
        newWindow.document.close();
      }

    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  const handleOnClickEnviarEMail = async (item) => {
    try {
      setLoading(true);

      const idCliente = item.IdCliente;

      if (!idCliente) {
        alert("No se encontró un cliente asociado al Documento de Venta.");
        return;
      }

      // Llamar a la función para obtener la dirección de correo del cliente
      const resultCliente = await function_ABM_EEX_Clientes_Leer(idCliente);
      const correoElectronico = resultCliente?.data.Emails?.replace(" ", "; ") || "";

      // Mostrar popup para confirmar o editar el correo
      const nuevoCorreo = window.prompt(
        "Se enviará el E-Mail a la siguiente dirección o ingrese una nueva:",
        correoElectronico
      );

      if (!nuevoCorreo) {
        alert("El envío ha sido cancelado.");
        return;
      }

      const formato = "pdf"
      const reportData = await function_VEN_DocsVenta_Cabecera_ReporteDocVenta_EnvioMail(item.IdDocVenta, item.Turno, nuevoCorreo);

      alert("Se ha enviado el E-Mail")
    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaginaListado
      Titulo="DOCUMENTOS DE VENTA"
      funcion={function_VEN_DocsVenta_Cabecera_Listar}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/VEN_DocsVenta_ModificacionCreacion/--NUEVO--" visible={false} />
          <LVButtonReporte Url="/VEN_Reporte_DocsVenta_AgrupadoPorArticulo" Texto="AGRUPADOS POR ART." />
          <LVButtonReporte Url="/VEN_Reporte_DocsVenta_AgrupadoPorVendedorZona" Texto="AGRUPADOS POR VENDEDOR/ZONA" />
          <LVButtonReporte Url="/VEN_Reporte_DocsVenta_PercepcionesRealizadas" Texto="PERCEPCIONES REALIZADAS" />
          <LVButtonReporte Url="/VEN_Reporte_DocsVenta_ListarConDetalles" Texto="VENTAS CON DETALLES" />
          <LVButtonReporte Url="/VEN_Reporte_DocsVenta_Comisiones" Texto="COMISIONES" />          
          <LVButtonReporte Url="/VEN_Reporte_DocsVenta_CMV" Texto="C.M.V." />                    
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdDocVenta"
            urlEdicion="/VEN_DocsVenta_ModificacionCreacion"
            onClickPrint={handleOnClickPrint}
            onClickEnviarEmail={handleOnClickEnviarEMail}
          >
            <Summary>
              <TotalItem
                column="IdDocVenta"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="ImporteNetoConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteBonificacionesItemsConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteRecargosItemsConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteBonificacionesConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteRecargosConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteTotalConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="ImporteTotalPostImpuestosConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="ImporteRecibidoConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />

              <GroupItem
                column="IdDocVenta"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteNetoConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteIVAConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteBonificacionesConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteRecargosConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteTotalConNCEnNegativo"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number"
                showInGroupFooter={true} />
            </Summary>

            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={true} />
            </Column>

            <Column caption="Código" dataField="IdDocVenta" width="80" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="FEFecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Número" dataField="FENumeroFantasia" width="135" alignment="Left" dataType="string" />
            <Column caption="Razón Social" dataField="ABM_EEX_Clientes_RazonSocial" width="100%" minWidth={130} alignment="Left" dataType="string" />
            <Column caption="Tipo" dataField="VEN_DocsVenta_Tipos_Descripcion" width="90" alignment="Left" dataType="string" />
            <Column caption="Estado" dataField="TODOS_Estados_Descripcion" width="100" alignment="Left" dataType="string" />

            <Column caption="Importes" alignment="Center">
              <Column caption="Moneda" dataField="ABM_CON_Monedas_Descripcion" width="70" alignment="Left" dataType="string" visible={false} />
              <Column caption="Cotización" dataField="Cotizacion" width="70" alignment="Right" dataType="number" format="currency" visible={false} />

              <Column caption="Neto" dataField="ImporteNetoConNCEnNegativo" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="I.V.A." dataField="ImporteIVA" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="Descuentos" dataField="ImporteBonificacionesConNCEnNegativo" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Recargos" dataField="ImporteRecargosConNCEnNegativo" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Desc.Items" dataField="ImporteBonificacionesItemsConNCEnNegativo" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Recs.Items" dataField="ImporteRecargosItemsConNCEnNegativo" width="100" alignment="Right" dataType="number" format="currency" />
              <Column caption="Total" dataField="ImporteTotalConNCEnNegativo" width="120" alignment="Right" dataType="number" format="currency" />
              <Column caption="Total P.I." dataField="ImporteTotalPostImpuestosConNCEnNegativo" width="110" alignment="Right" dataType="number" format="currency" />
              <Column caption="Recibido" dataField="ImporteRecibidoConNCEnNegativo" width="110" alignment="Right" dataType="number" format="currency" />
            </Column>

            <Column caption="C.A.E." dataField="CAE" width="130" alignment="Left" dataType="string" />
            <Column caption="Creador" dataField="I_UsuarioCreador" width="130" alignment="Left" dataType="string" visible={false} />
            <Column caption="Planta" dataField="CodigoPlanta" width="80" alignment="Left" dataType="string" visible={false} />
            <Column caption="Term." dataField="Terminal" width="80" alignment="Right" dataType="number" />
            <Column caption="Turno" dataField="Turno" width="80" alignment="Right" dataType="number" visible={false} />
            <Column caption="Peso" dataField="I_PesoTotal" width="80" alignment="Right" dataType="number" />

            <Column caption="Concepto" dataField="Concepto" width="100" alignment="Left" dataType="string" visible={false} />
            <Column caption="Observaciones" dataField="Observaciones" width="100" alignment="Left" dataType="string" visible={false} />
            <Column caption="Creador" dataField="I_UsuarioCreador" width="100" alignment="Left" dataType="string" />

            <MasterDetail
              enabled={true}
              component={VEN_DocsVenta_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
